import React, { useState } from "react";
import "./ManageServicesList.css";
import Widgets from "../../../../widgets";
import plusIcon from "../../../../Assets/Icons/PlusIcon.png";
import { useTranslation } from "react-i18next";
import MRList from "./MRList";
import strings from "../../../../utils/strings";
import { useNavigate } from "react-router-dom";

const ManageServicesList = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const breadcrumbs = ["nursingCare", "manageService"];
  const paths = [strings.navigation.nursingCareManageService, strings.navigation.nursingCareManageService];
  const [searchValue, setSearchValue] = useState("");
  const [entrySummary, setEntrySummary] = useState({ displayed: 0, total: 0 });

  return (
    <div className="mr-container">
      <Widgets.BreadCrumb breadcrumbs={breadcrumbs} paths={paths} />
      <div className="manage-service-heading">{t("services")}</div>
      <div className="manage-service-search-line">
        <Widgets.SearchBox placeholder={"searchByServiceGroup"}
          value={searchValue}
          onSearch={(value) => setSearchValue(value)}
        />
        <Widgets.IconButton iconSrc={plusIcon} buttonText="addService" onClick={() => navigate(strings.navigation.createService)}/>          
      </div>
      <div className="manage-service-entry-summary">
        Showing {entrySummary.displayed} entries of {entrySummary.total} total
      </div>
      <div className="mr-list-box">
        <MRList searchValue={searchValue} onEntrySummaryChange={setEntrySummary} />
      </div>
    </div>
  );
};

export default ManageServicesList;
